<template>
    <div>
        <div class="page-title">
            <h4 > Settings </h4>
        </div>
        <div class="table-header edit-header">
            <div class="search-box" v-if="$can(['update global settings'])">
                <router-link :to="`/settings/edit`">
                    <button type="button" class="add-user edit-button">
                        <i class="far fa-edit"></i>
                        <span> {{$t('placeholder.editeaza')}} </span>
                    </button>
                </router-link>
            </div>
        </div>
        <div class="add-user-form">
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_1" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                      <i :class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_2" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                      <i v-bind:class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SettingsService from '../../api-services/settings.service.js'

export default {
  name: 'ViewSettings',
  data () {
    return {
      settings: {
        phone: null,
        email: null,
        company_name: null,
        cui: null,
        nr_reg_com: null,
        iban: null,
        bank: null,
        county: null,
        city: null,
        address: null
      }
    }
  },
  methods: {
    getSettings () {
      SettingsService.get()
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.settings = response.data.data
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: (this.settings) ? this.settings.company_name : null,
            icon: 'fas fa-building'
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: (this.settings) ? this.settings.phone : null,
            icon: 'fas fa-phone'
          },
          {
            inputName: 'cui',
            labelName: this.$t('placeholder.cui'),
            inputValue: (this.settings) ? this.settings.cui : null,
            icon: 'fas fa-scroll'
          },
          {
            inputName: 'nr_reg_com',
            labelName: this.$t('placeholder.nrRegCom'),
            inputValue: (this.settings) ? this.settings.nr_reg_com : null,
            icon: 'fas fa-cash-register'
          },
          {
            inputName: 'bank',
            labelName: this.$t('placeholder.banca'),
            inputValue: (this.settings) ? this.settings.bank : null,
            icon: 'fas fa-piggy-bank'
          }
        ],
        column_2: [
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: (this.settings) ? this.settings.email : null,
            icon: 'fas fa-envelope'
          },
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            inputValue: (this.settings && this.settings.county) ? this.settings.county.name : null,
            icon: 'fas fa-map-marker-alt',
            validationRules: 'alpha'
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            inputValue: (this.settings && this.settings.city) ? this.settings.city.name : null,
            icon: 'fas fa-map-marker-alt',
            validationRules: 'alpha'
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: (this.settings) ? this.settings.address : null,
            icon: 'fas fa-map-marker-alt'
          },
          {
            inputName: 'iban',
            labelName: this.$t('placeholder.iban'),
            inputValue: (this.settings) ? this.settings.iban : null,
            icon: 'fas fa-piggy-bank'
          }
        ]
      }
    }
  },
  created () {
    this.getSettings()
  }
}
</script>
